export default __webpack_public_path__ + "static/media/maillicon.4938a4a2.svg";